import { ReactNode } from "react";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";

interface Props {
  flag: string;
  fallback?: ReactNode;
  children: ReactNode;
}

export function FeatureFlag({ flag, fallback = null, children }: Props) {
  const { enabled, loading } = useFeatureFlag(flag);
  if (loading) return null;
  if (!enabled) return <>{fallback}</>;
  return <>{children}</>;
}
